import DOMPurify from 'dompurify';

const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['style', 'target', 'rel']
  });

export default sanitizeHtml;
